import { render, staticRenderFns } from "./TagCloseIcon.vue?vue&type=template&id=2834b2e0"
import script from "./TagCloseIcon.vue?vue&type=script&lang=js"
export * from "./TagCloseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports